import { useEffect, useRef, useState } from "react";
import {
    AccordionDetailsNoteStyled,
    AccordionNoteStyled,
    AccordionSummaryNoteStyled,
    useClasses,
} from "./OrderOfferNote.style";
import { Button, TextField, Typography } from "@mui/material";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { useFormClasses } from "./CreateOfferOrderForm.style";

type OrderOfferNoteProps = {
    value: string;
    onChange: any;
};

const OrderOfferNote: React.FC<OrderOfferNoteProps> = (props) => {
    
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const { t } = useTranslation();
    const classes = useClasses();
    const classesForm=useFormClasses();

    const [noteEdited, setNoteEdited] = useState<string | null>();
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNoteEdited(event.target.value);
        props.onChange(event, event.target.value.toString());
    };

    useEffect(() => {
        if (props?.value !== undefined) {
            setNoteEdited(props?.value);
        }
    }, [props?.value]);

      return (
          <>
              <Typography
                  variant="body2"
                  color="primary"
                  component="span"
                  sx={classesForm.title}
              >
                  {t("orderoffer.note")}
              </Typography>

              <TextField
                  id="comments"
                  sx={classes.multiline}
                  inputRef={textareaRef}
                  fullWidth
                  margin="none"
                  multiline
                  variant="outlined"
                  slotProps={{
                      inputLabel: { shrink: true, sx: classes.titleComment },
                      input: { sx: classes.inputMultiline },
                  }}
                  rows={4}
                  
                  onChange={handleInputChange}
                  value={noteEdited}
              />
          </>
      );
};
export default OrderOfferNote;
